import { useCallback, useEffect, useState } from 'react';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

let _visitPinged = false;

export function useSiteStats() {
  const [stats, setStats] = useState(null);
  const [loading, setLoading] = useState(true);

  const fetchStats = useCallback(async () => {
    try {
      const r = await fetch(`${API}/track/stats`, { credentials: 'include' });
      if (r.ok) {
        const data = await r.json();
        setStats(data);
      }
    } catch { /* ignore */ } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    // Ping visit once per tab session
    if (!_visitPinged) {
      _visitPinged = true;
      fetch(`${API}/track/visit`, {
        method: 'POST',
        credentials: 'include',
      }).catch(() => {}).finally(() => fetchStats());
    } else {
      fetchStats();
    }
    // Refresh stats every 60s
    const t = setInterval(fetchStats, 60000);
    return () => clearInterval(t);
  }, [fetchStats]);

  return { stats, loading, refresh: fetchStats };
}
